import { useEffect } from 'react'

import { useInfiniteScroll } from 'ahooks'

import { isSuccess } from '@/httpRequest'
import {
  getSessionHistory,
  ISessionHistoryResponse
} from '@/httpRequest/modules/mesperyIm/sessionHistory'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import { useGlobalLoading } from '@/store/globalLoading'

const PAGE_SIZE = 20

export const useHistoryMessages = () => {
  const {
    currentConversation,
    messageData,
    setMessageData,
    setLoadMoreHistory
  } = useMessageAtom()
  const { setGlobalLoading } = useGlobalLoading()

  // 新的历史消息获取方法，使用start_id游标分页
  const handleGetHistoryMessages = async (startId?: string) => {
    if (!currentConversation) {
      return { list: [], next: false }
    }

    setGlobalLoading(true)

    const resp = await getSessionHistory({
      session_id: currentConversation.session_id,
      session_type: currentConversation.session_type,
      size: PAGE_SIZE,
      ...(startId ? { start_id: startId } : {})
    })

    setGlobalLoading(false)

    if (isSuccess(resp)) {
      if (resp.data.list.length > 0) {
        if (messageData?.list && resp.data?.list) {
          const listData = resp.data.list.toReversed()
          const list = listData.concat(messageData.list)
          setMessageData({ ...resp.data, list })
        } else {
          const listData = resp.data.list.toReversed()
          setMessageData({ ...resp.data, list: listData })
        }

        return resp.data
      }
    }

    return {
      list: [],
      next: false
    }
  }

  const { data, mutate, loadMore, loading, loadingMore, reload, noMore } =
    useInfiniteScroll<ISessionHistoryResponse>(
      (nowData) => {
        let startId: string | undefined = undefined
        if (nowData && nowData.list && nowData.list.length > 0) {
          // 取当前已加载消息中最早一条的 id 作为下一页的 start_id
          startId = nowData.list[nowData.list.length - 1].id
        }
        return handleGetHistoryMessages(startId)
      },
      {
        isNoMore: (nowData) => {
          if (nowData) {
            return !nowData.next
          }
          return false
        }
      }
    )

  useEffect(() => {
    setLoadMoreHistory(loadingMore || loading)
  }, [loadingMore, loading])

  return {
    data,
    mutate,
    loadMore,
    loading,
    loadingMore,
    reload,
    noMore
  }
}
